import { render, staticRenderFns } from "./OptionsMealsCustom.vue?vue&type=template&id=4f39dffa&scoped=true&"
import script from "./OptionsMealsCustom.vue?vue&type=script&lang=js&"
export * from "./OptionsMealsCustom.vue?vue&type=script&lang=js&"
import style0 from "./OptionsMealsCustom.vue?vue&type=style&index=0&id=4f39dffa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f39dffa",
  null
  
)

export default component.exports